export const ar = {
	Statistiken: 'الاحصائيات',
	'Verwerfen bestätigen': 'تأكيد التجاهل',
	'Möchten Sie wirklich zur Fragebank zurückkehren?': 'هل تريد حقًا العودة إلى بنك الأسئلة؟',
	Kategorie: 'الفئة',
	Frage: 'سؤال',
	Speichern: 'حفظ',
	Abbrechen: 'إلغاء',
	Verwerfen: 'تجاهل',
	Schließen: 'إغلاق',
	'Ja, umsetzen': 'نعم، نفذ',
	'Löschen bestätigen': 'تأكيد الحذف',
	'Möchten Sie {{name}} wirklich löschen?': 'هل تريد حقًا حذف {{name}}؟',
	'Fragenummer {{number}}': 'رقم السؤال {{number}}',
	'Kategorie hinzufügen': 'إضافة فئة',
	'Kategorie bearbeiten': 'تحرير الفئة',
	'Kategorie löschen': 'حذف الفئة',
	Name: 'الاسم',
	'Name der Kategorie': 'اسم الفئة',
	Fragebank: 'بنك الأسئلة',
	'Frage bearbeiten': 'تحرير السؤال',
	'Frage löschen': 'حذف السؤال',
	'Koran /von-bis': 'القرآن / من إلى',
	Andere: 'آخر',
	'Von Aaya': 'من آية',
	'Bis Aaya': 'إلى آية',
	'Frage hinzufügen': 'إضافة سؤال',
	'Neue Frage hinzufügen': 'إضافة سؤال جديد',
	Antwort: 'إجابة',
	Fragestufe: 'مستوى السؤال',
	'Sehr Leicht': 'سهل جدا',
	Leicht: 'سهل',
	Mittel: 'متوسط',
	Schwer: 'صعب',
	'Sehr Schwer': 'صعب جدا',
	Aktionen: 'الإجراءات',
	Details: 'تفاصيل',
	'Anzahl der Fragen': 'عدد الأسئلة',
	"Fragekategorie '{{name}}' wurde erfolgreich gelöscht.": "تم حذف فئة الأسئلة '{{name}}' بنجاح.",
	'Fragekategorie wurde erfolgreich erstellt.': 'تم إنشاء فئة الأسئلة بنجاح.',
	'Fragekategorie wurde erfolgreich gelöscht.': 'تم حذف فئة الأسئلة بنجاح.',
	'{{items}} von {{totalCount}} werden angezeigt': 'يتم عرض {{items}} من {{totalCount}}',
	Suche: 'بحث',
	Fragetyp: 'نوع السؤال',
	'Von ist erforderlich': 'من حقل اجباري',
	'Bis ist erforderlich': 'الى حقل اجباري',
	'Antwort ist erforderlich': 'الاجابة حقل اجباري',
	'Frage ist erforderlich': 'السؤال حقل اجباري',
	'Kategorie ist erforderlich': 'الفئة حقل اجباري',
	'Der Quran von Sure {{fromSuraName}} „{{fromAaya}} ({{fromAayaId}})” bis Sure {{toSuraName}} „{{toAaya}} ({{toAayaId}})”':
		'القرآن من سورة {{fromSuraName}} “{{fromAaya}} ({{fromAayaId}})” إلى سورة {{toSuraName}} “{{toAaya}} ({{toAayaId}})“',
	'Frage Details: {{name}}': 'تفاصيل السؤال: {{name}}',
	'Keine Fragen gefunden': 'لم يتم العثور على أسئلة',
	'Jury erfolgreich erstellt': 'تم إنشاء اللجنة بنجاح',
	'Jury erfolgreich gelöscht': 'تم حذف اللجنة بنجاح',
	'Jury erfolgreich aktualisiert': 'تم تحديث اللجنة بنجاح',
	'Vorname ist erforderlich': 'الاسم الأول حقل اجباري',
	'Nachname ist erforderlich': 'اسم العائلة حقل اجباري',
	Vorname: 'الاسم الأول',
	Nachname: 'اسم العائلة',
	'Benutzer Management': 'إدارة المحكمين',
	'Benutzer hinzufügen': 'إضافة محكم',
	'Fehler beim Löschen der Filiale': 'خطأ في حذف الفرع',
	'Fehler beim Löschen der Benutzer': 'خطأ في حذف ابمحكم',
	'Name ist erforderlich': 'الاسم حقل اجباري',
	'Adresse ist erforderlich': 'العنوان حقل اجباري',
	'Filiale hinzufügen': 'إضافة فرع',
	'Filialen Management': 'إدارة الفروع',
	Adresse: 'العنوان',
	'Keine Daten gefunden': 'لم يتم العثور على بيانات',
	Bewertungsparameter: 'معايير التقييم',
	'Bewertungen und Gewichtungen': 'التقييمات والأوزان',
	Kategoriefragen: 'أسئلة الفئة',
	'Fragen zur Kategoriezulassung': 'أسئلة الفئة',
	Alter: 'العمر',
	Geschlecht: 'الجنس',
	'Von /Altersgruppe': 'من / العمر',
	'Bis /Altersgruppe': 'إلى / العمر',
	'Rezitation Dauer': 'مدة التلاوة',
	Qualifikationen: 'تدعم التصفيات',
	Ja: 'نعم',
	Nein: 'لا',
	'in Min': 'بالدقائق',
	Beschreibung: 'الوصف',
	Nächste: 'التالي',
	Vorherige: 'السابق',
	'Mindestalter muss kleiner als das Höchstalter sein': 'يجب أن يكون الحد الأدنى للعمر أقل من الحد الأقصى للعمر',
	'Mindestalter ist erforderlich': 'الحد الأدنى للعمر حقل اجباري',
	'Mindestalter muss größer als 0 sein': 'يجب أن يكون الحد الأدنى للعمر أكبر من 0',
	'Höchstalter ist erforderlich': 'الحد الأقصى للعمر حقل اجباري',
	'Höchstalter muss größer als 0 sein': 'يجب أن يكون الحد الأقصى للعمر أكبر من 0',
	'Dauer ist erforderlich': 'المدة حقل اجباري',
	'Dauer muss größer als 0 sein': 'يجب أن تكون المدة أكبر من 0',
	Gesamtpunktzahl: 'مجموع النقاط',
	'Gesamtpunktzahl ist erforderlich': 'مجموع النقاط حقل اجباري',
	'Gesamtpunktzahl muss größer als 0 sein': 'يجب أن تكون مجموع النقاط أكبر من 0',
	Fehlertyp: 'نوع الخطأ',
	Allgemein: 'عام',
	Privat: 'خاص',
	Speziell: 'خاص',
	Selektortyp: 'نوع المحدد',
	'Keine Optionen': 'لم يتم العثور على خيارات',
	Punkte: 'النقاط',
	'Punkte ist erforderlich': 'النقاط حقل اجباري',
	Prozentual: 'نسبي',
	Gewichtsart: 'نوع الوزن',
	'Gewichtung muss größer als 0 sein': 'يجب أن تكون الوزن أكبر من 0',
	Breite: 'العرض',
	Voll: 'كامل',
	Halb: 'نصف',
	Pflichtfeld: 'حقل اجباري',
	'Kategorien Management': 'إدارة الفئات',
	'Kategorie erfolgreich erstellt': 'تم إنشاء الفئة بنجاح',
	'Kategorie erfolgreich aktualisiert': 'تم تحديث الفئة بنجاح',
	Altersgruppe: 'العمر',
	Rezitationsdauer: 'مدة التلاوة',
	Unisex: 'غير محدد',
	'Kategorie erfolgreich gelöscht': 'تم حذف الفئة بنجاح',
	'Frage wurde erfolgreich erstellt': 'تم إنشاء السؤال بنجاح',
	'Kategorie Details: {{name}}': 'تفاصيل الفئة: {{name}}',
	'Keine angaben': 'لا توجد معلومات',
	Gewicht: 'وزن العلامة',
	'Filiale erfolgreich erstellt': 'تم إنشاء الفرع بنجاح',
	'Filiale erfolgreich gelöscht': 'تم حذف الفرع بنجاح',
	'Filiale erfolgreich aktualisiert': 'تم تحديث الفرع بنجاح',
	'Benutzer erfolgreich gelöscht': 'تم حذف المحكم بنجاح',
	'Möchten Sie wirklich abbrechen?': 'هل تريد بالفعل الإلغاء؟',
	'Wettbewerbe Management': 'إدارة المسابقات',
	'Wettbewerb hinzufügen': 'إضافة مسابقة',
	'Informationen zum Wettbewerb': 'معلومات عن المسابقة',
	Datum: 'التاريخ',
	Art: 'النوع',
	'Startdatum des Wettbewerbs': 'تاريخ بدء المسابقة',
	'Startdatum der Registrierung': 'تاريخ بدء التسجيل',
	'Ablaufdatum der Registrierung': 'تاريخ انتهاء التسجيل',
	Registrierungsstatus: 'حالة التسجيل',
	'Teilnehmende Kategorien': 'الفئات المشاركة',
	'Startdatum ist erforderlich': 'تاريخ البدء حقل اجباري',
	'Datum darf nicht in der Vergangenheit liegen': 'لا يجب أن يكون التاريخ في الماضي',
	'Startdatum der Anmeldung ist erforderlich': 'تاريخ بدء التسجيل حقل اجباري',
	'Startdatum der Anmeldung muss vor dem Startdatum des Wettbewerbs liegen':
		'يجب أن يكون تاريخ بدء التسجيل قبل تاريخ بدء المسابقة',
	'Enddatum der Anmeldung ist erforderlich': 'تاريخ نهاية التسجيل حقل اجباري',
	'Enddatum der Anmeldung muss vor dem Startdatum des Wettbewerbs liegen':
		'يجب أن يكون تاريخ نهاية التسجيل قبل تاريخ بدء المسابقة',
	'Enddatum der Anmeldung muss nach dem Startdatum der Anmeldung liegen':
		'يجب أن يكون تاريخ نهاية التسجيل بعد تاريخ بدء التسجيل',
	'Ziehen Sie Ihre Datei(en), um den Upload zu starten': 'اسحب ملفك (ملفاتك) لبدء التحميل',
	Oder: 'أو',
	'Datei auswählen': 'تصفح الملفات',
	'Erstellen Sie Kategoriefragen': 'إنشاء أسئلة الفئة',
	Kategorietyp: 'نوع الفئة',
	Jury: 'اللجان',
	'Jury Management': 'إدارة اللجان',
	'Prüfer hinzufügen': 'إضافة محكم',
	'Prüfer Management': 'إدارة المحكمين',
	'Fügen Sie die am Wettbewerb teilnehmenden Kategorien hinzu. Für jede Kategorie müssen Sie die Bewertungsgremien, den Ort des Wettbewerbs, die Fragen und deren Anzahl angeben':
		'قم بإضافة الفئات المشاركة في المسابقة, من أجل كل فئة ستحتاج لتعيين لجان التقييم و مكان المسابقة و الأسئلة و عددها',
	'Name des Kategorie': 'اسم الفئة',
	'Alter von {{from}}-{{to}} Jahre': 'العمر من {{from}}-{{to}} سنة',
	'Standorte der Kategorien': 'مواقع الفئات',
	'Fragetyp {{index}}': 'نوع السؤال {{index}}',
	'Fragestufe {{index}}': 'مستوى السؤال {{index}}',
	'Fügen Sie qualifizierende Fragen hinzu für {{name}}': 'قم بإضافة اسئلة التصفيات لـ {{name}}',
	'{{name}} ist erforderlich': '{{name}} حقل اجباري',
	'{{name}} muss größer als 0 sein': '{{name}} يجب أن يكون أكبر من 0',
	'Name des Juries': 'اسم اللجنة',
	'Fehler beim Löschen des Jurors': 'خطأ في حذف اللجنة',
	'Jury hinzufügen': 'إضافة لجنة',
	'Vorsitzender der Jury': 'رئيس اللجنة',
	'{{index}}. Prüfer': 'المحكم {{index}}',
	Prüfer: 'المحكم',
	'Es darf nicht den gleichen Prüfer ausgewählt werden': 'لا يمكن اختيار نفس المحكم',
	'Wettbewerb auswählen': 'اختر مسابقة',
	'Neuen Fehler hinzufügen': 'إضافة خطأ جديد',
	'Neue Kategorie hinzufügen': 'إضافة فئة جديدة',
	'Wettbewerb erfolgreich erstellt': 'تم إنشاء المسابقة بنجاح',
	'Wettbewerb erfolgreich gelöscht': 'تم حذف المسابقة بنجاح',
	'Wettbewerb erfolgreich aktualisiert': 'تم تحديث المسابقة بنجاح',
	'Frage erfolgreich gelöscht': 'تم حذف السؤال بنجاح',
	'Die qualifizierenden Fragen für die Kategorie {{name}}': 'الأسئلة المؤهلة للفئة {{name}}',
	'Höchstalter muss größer als das Mindestalter sein': 'يجب أن يكون الحد الأقصى للعمر أكبر من الحد الأدنى للعمر',
	Offen: 'مفتوح',
	Bewerbung: 'تطبيق',
	Bereit: 'جاهز',
	'In Bearbeitung': 'قيد التنفيذ',
	Erledigt: 'منجز',
	Abgesagt: 'ملغى',
	'Jury Code erfolgreich erstellt': 'تم إنشاء رمز اللجنة بنجاح',
	'Finale Fragen müssen größer als 0 sein': 'يجب أن تكون الأسئلة النهائية أكبر من 0',
	'Status erfolgreich geändert': 'تم تغيير الحالة بنجاح',
	'Bearbeiten Sie Kategoriefragen': 'تحرير أسئلة الفئة',
	'Wettbewerb bearbeiten': 'تحرير المسابقة',
	'URL kopieren': 'نسخ الرابط',
	'URL erfolgreich kopiert.': 'تم نسخ الرابط بنجاح',
	'Die Datei darf nicht größer als {{size}} MB sein': 'لا يجب أن يكون حجم الملف أكبر من {{size}} ميغابايت',
	'Kategorie {{number}}': 'الفئة {{number}}',
	'{{name}} Wettbewerb teilnehmen': 'المشاركة في {{name}}',
	Geburtstag: 'تاريخ الميلاد',
	Telefon: 'رقم الهاتف',
	'E-Mail': 'البريد الإلكتروني',
	'Straße und Hausnummer': 'الشارع ورقم المنزل',
	PLZ: 'الرمز البريدي',
	Stadt: 'المدينة',
	'Dein Alter entspricht nicht den Anforderungen, es muss zwischen {{min}} und {{max}} Jahren liegen':
		'عمرك لا يتوافق مع المتطلبات, يجب أن يكون بين {{min}} و {{max}} سنة',
	'Ungültige E-Mail-Adresse': 'عنوان بريد إلكتروني غير صالح',
	'Bitte füllen Sie alle Felder aus, sicherzustellen, dass alle Felder korrekt ausgefüllt sind':
		'يرجى ملء جميع الحقول للتأكد من أن جميع الحقول معبأة بشكل صحيح',
	Senden: 'إرسال',
	'Bewertungs Management': 'إدارة التقييم',
	'Ergebnis anzeigen': 'عرض النتيجة',
	'Klicken zur Auswertung': 'انقر للتقييم',
	Status: 'الحالة',
	'Jury Name': 'اسم اللجنة',
	'Gewinner anzeigen': 'عرض الفائزين',
	'Abzug zurückziehen': 'تراجع عن الخصم ',
	Geburtsdatum: 'تاريخ الميلاد',
	'Erstellt am': 'تم الإنشاء في',
	'Teilnehmer Management': 'إدارة المشاركين',
	'Teilnehmer hinzufügen': 'إضافة مشارك',
	'Teilnehmer akzeptieren': 'قبول المنتسبين',
	'Zur Jury hinzufügen': 'إضافة إلى اللجنة',
	'Verteilung der Teilnehmer auf die Jury': 'توزيع المشاركين على اللجنة',
	'Fügen Sie dem Panel ausgewählte Teilnehmer hinzu.': 'أضف المشاركين المحددين إلى اللجنة',
	'Jury auswählen': 'اختر اللجنة',
	Home: 'الصفحة الرئيسية',
	IZDB: 'المركز الثقافي للحوار والتأهيل',
	Muharram: 'محرم',
	Safar: 'صفر',
	'Rabi al-awwal': 'ربيع الأول',
	'Rabi al-thani': 'ربيع الثاني',
	'Jumada al-awwal': 'جمادى الأول',
	'Jumada al-thani': 'جمادى الثاني',
	Rajab: 'رجب',
	"Sha'ban": 'شعبان',
	Ramadan: 'رمضان',
	Shawwal: 'شوال',
	"Dhu al-Qi'dah": 'ذو القعدة',
	'Dhu al-Hijjah': 'ذو الحجة',
	'{{name}} beginnt in': 'يبدأ {{name}} في',
	'Wöchentliche Unterrichte': 'عرض البرنامج الأسبوعي',
	'Nächster Unterricht': 'الدرس القادم',
	'Nächste Aktivitäten': 'النشاط القادم',
	Live: 'بث مباشر',
	Aktivitäten: 'الأنشطة',
	'Restliche Zeit: {{time}}': 'الوقت المتبقي: {{time}}',
	Fajr: 'الفجر',
	Shurooq: 'الشروق',
	Iqamah: 'الإقامة',
	Dhuhr: 'الظهر',
	Asr: 'العصر',
	Maghrib: 'المغرب',
	Isha: 'العشاء',
	Morgens: 'صباحاً',
	Abends: 'مساءً',
	'Wöchentlicher Plan': 'البرنامج الأسبوعي',
	Einstellungen: 'الإعدادات',
	'Zu einem bestimmten Datum springen': 'الانتقال إلى تاريخ معين',
	Gebet: 'الصلاة',
	Pushbenachrichtigungen: 'إشعارات ',
	'Kontaktieren Sie uns': 'تواصل معنا',
	'Wer wir sind': 'من نحن',
	'Häufig gestellte Fragen': 'الأسئلة الشائعة',
	'Vollständiger Name': 'اسم الكامل',
	'Das Thema': 'الموضوع',
	Nachricht: 'الرسالة',
	'Sprache wählen': 'اختر اللغة',
	'Auf dem neuesten Stand bleiben': 'ابق على اطلاع',
	'Livestream, Veranstaltungen und mehr': 'بث مباشر, فعاليات والمزيد',
	Unterrichtsbenachrichtigungen: 'إشعارات الدروس',
	'Erinnerungen an Unterrichtsstunden': 'تذكير بجلسات الدروس',
	'Tägliche Koran-Erinnerungen': 'تذكيرات القرآن اليومية',
	'Erinnerungen an tägliche Koran-Lektionen': 'تذكير بدروس القرآن اليومية',
	'Tägliche Duaa-Erinnerungen': 'تذكيرات الدعاء اليومية',
	'Erinnerungen an tägliche Duaa-Lektionen': 'تذكير بدروس الدعاء اليومية',
	'Schreiben Sie hier': 'أكتب هنا',
	'Jetzt ist es Zeit zu beten': 'الوقت الان للصلاة',
	'Läuft ab in': 'تنتهي خلال',
	'Nächstes Gebet': 'الصلاة التالية',
	'Der Gebetsruf erklingt zur vollen Stunde': 'يرفع الآذان الساعة',
	'Um die Funktion bestmöglich nutzen zu können, bitte die Standortfreigabe aktivieren.':
		'للاستفادة القصوى من الوظيفة، يرجى تفعيل مشاركة الموقع.',
	'Iqamah Fajr': 'إقامة الفجر',
	'{{id}}. Freitagsgebet': '{{id}}. صلاة الجمعة',
	Freitagsgebet: 'صلاة الجمعة',
	'Beginnt um: {{value}} Uhr': 'يبدأ على الساعة {{value}}',
	'Bitte wähle einen genaueren Standort aus, um die Kompass-Funktion zu nutzen.':
		'يرجى اختيار موقع أكثر دقة لاستخدام وظيفة البوصلة.',
	'Genaueren Standort auswählen': 'اختيار موقع أكثر دقة',
	Montag: 'الاثنين',
	Dienstag: 'الثلاثاء',
	Mittwoch: 'الأربعاء',
	Donnerstag: 'الخميس',
	Freitag: 'الجمعة',
	Samstag: 'السبت',
	Sonntag: 'الأحد',
	'Ihre Nachricht wurde erfolgreich gesendet': 'تم إرسال رسالتك بنجاح',
	'Einmalige Spende': 'تبرع مرة واحدة',
	'Monatliche Wohltätigkeit': 'التبرع الشهري',
	'Abschluss der Spende mit {{value}}': 'إكمال التبرع بقيمة {{value}}',
	'Spendenbetrag muss mindestens 10€ betragen': 'يجب أن يكون مبلغ التبرع 10 يورو على الأقل',
	'Der Betrag muss größer als 0 sein': 'يجب أن يكون المبلغ أكبر من 0',
	'Notizen hinzufügen': 'إضافة ملاحظات',
	Spenden: 'التبرعات',
	'Die Spende war erfolgreich, und wir schätzen deinen Beitrag zur Unterstützung der bedürftigen Empfänger. Dank deiner Großzügigkeit kommen wir einen Schritt näher an die Erreichung der Kampagnenziele und die Hilfe für diejenigen, die sie am dringendsten benötigen.':
		'تم التبرع بنجاح، ونقدر مساهمتك في دعم المستفيدين المحتاجين. بفضل سخائك، نحن نقترب خطوة أقرب من تحقيق أهداف الحملة ومساعدة أولئك الذين يحتاجون إليها بشدة.',
	'Sie haben erfolgreich gespendet!': 'لقد تبرعت بنجاح!',
	'Jetzt spenden': 'تبرع الآن',
	'Sofort. Übers.': 'ترجمة فورية. ',
	'Gebetsruf-Erinnerungen': 'تذكيرات الأذان',
	'Erinnerungen an Gebetsrufe': 'تذكيرات الأذان',
	Ishaa: 'العشاء',
	'Mit Sheikh {{name}}': 'مع الشيخ {{name}}',
	'Imam Fragen': 'طرح سؤال فتوى',
	'Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.': 'يرجى التحقق من اتصالك وحاول مرة أخرى.',
	'Keine Internetverbindung': 'لا يوجد اتصال بالإنترنت',
	'Erneut versuchen': 'حاول مرة أخرى',
	'Qibla Kompass': 'بوصلة القبلة',
	'Ma’thurat für abends': 'أذكار المساء',
	'Ma’thurat für den Morgen': 'أذكار الصباح',
	'Trage mit einem Klick zum Guten bei': 'ساهم في الخير بنقرة واحدة',
	'Deine Spende heute kann anhaltendes Gutes bewirken – als laufende Wohltat, Hilfe für ein Zentrum oder lebensrettende Nothilfe.':
		'تبرعك اليوم قد يكون صدقة جارية، أو دعمًا لمركز خيري، أو إغاثة عاجلة تنقذ روحًا أو تسدّ حاجة.',
	'Art der Spende': 'انواع التبرع',
	'Über uns': 'من نحن',
	'Sie haben erfolgreich angemeldet!': 'لقد قمت بالتسجيل بنجاح!',
	'Wir freuen uns über deine Teilnahme und danken dir für dein Engagement. Mit deiner Anmeldung trägst du aktiv zum Gelingen der Veranstaltung bei und unterstützt unsere gemeinsame Mission. Gemeinsam schaffen wir wertvolle Erlebnisse und machen einen echten Unterschied.':
		'نحن سعداء بمشاركتك ونشكرك على التزامك. من خلال تسجيلك، تساهم بنشاط في نجاح الحدث وتدعم مهمتنا المشتركة. معًا، نخلق تجارب قيمة ونحدث فرقًا حقيقيًا.',
	'Zurück zur Startseite': 'العودة إلى الصفحة الرئيسية',
	'Jetzt anmelden': 'سجل الآن',
	'Haben Sie eine religiöse Frage?': 'هل لديك سؤال ديني؟',
	'Schreiben Sie dem Imam über dieses Formular - Sie erhalten schnellstmöglich eine Antwort.':
		'لديك سؤال شرعي؟ اطرحه على الشيخ من خلال هذا القسم، وسيتم الرد عليك في أقرب وقت ممكن إن شاء الله.',
	'Was bietet Das Interkulturelle Zentrum für Dialog und Bildung (IZDB) an?':
		'ماذا يقدم المركز الثقافي للحوار والتأهيل',
	'Dialog und Bildung': 'الحوار والتعليم',
	'Das Interkulturelle Zentrum für Dialog und Bildung (IZDB) bietet einen offenen und einladenden Raum für alle Interessierten, die Fragen an und über den Islam, sowie über Muslime und ihre Kultur stellen möchten. Das Zentrum dient als eine Plattform für Frieden, Besinnung und Bildung und fördert eine positive Kommunikation zwischen verschiedenen Kulturen und Religionen. Es ist bestrebt, Verständnis und Respekt durch Dialog zu fördern und bietet eine Vielzahl von Bildungsprogrammen, Workshops und Veranstaltungen, die darauf abzielen, ein tieferes Verständnis des islamischen Glaubens und der muslimischen Gemeinschaften zu vermitteln. Das IZDB ist ein Ort der Begegnung, wo Menschen unterschiedlicher Herkunft zusammenkommen können, um voneinander zu lernen und gemeinsame Werte zu teilen.':
		'يقدم المركز الثقافي للحوار والتعليم مساحة مفتوحة ومرحبة لجميع الأطراف المهتمة الذين يرغبون في طرح الأسئلة حول الإسلام، وكذلك حول المسلمين وثقافتهم. ويعمل المركز كمنصة للسلام والتأمل والتعليم، ويعزز التواصل الإيجابي بين الثقافات والأديان المختلفة. ويسعى المركز إلى تعزيز التفاهم والاحترام من خلال الحوار ويقدم مجموعة متنوعة من البرامج التعليمية وورش العمل والفعاليات التي تهدف إلى توفير فهم أعمق للعقيدة الإسلامية والمجتمعات المسلمة. IZDB هو مكان اجتماع حيث يمكن للأشخاص من خلفيات مختلفة أن يجتمعوا معًا للتعلم من بعضهم البعض ومشاركة القيم المشتركة.',
	'Wir engagieren uns für die Förderung von gegenseitigem Verständnis und positivem Zusammenleben durch konstruktiven Dialog. Dieser Austausch erfolgt auf mehreren Ebenen und umfasst die Zusammenarbeit mit muslimischen Gemeinschaften, anderen religiösen Gruppen sowie säkularen Vereinen und Institutionen. Das Interkulturelle Zentrum für Dialog und Bildung (IZDB) fungiert als zentraler Treffpunkt und Plattform für den interkulturellen und interreligiösen Austausch. Wir organisieren eine Vielzahl von Veranstaltungen wie Vortragsreihen, Seminare und Workshops, die sowohl in deutscher als auch in arabischer Sprache angeboten werden. Diese Veranstaltungen sind darauf ausgerichtet, sowohl Muslime als auch Nicht-Muslime zu informieren und zu bilden. Durch diese Bildungsangebote streben wir danach, Gemeinsamkeiten zu identifizieren, Missverständnisse zu klären und Vorurteile abzubauen. Unser Ziel ist es, ein tieferes Verständnis und Respekt unter den verschiedenen Gemeinschaften zu fördern und uns gemeinsam für ein friedvolles Miteinander in unserer Gesellschaft einzusetzen. In diesem Sinne dient das IZDB als ein lebendiges Zentrum des Lernens und des Dialogs, das die Vielfalt der Kulturen und Religionen als Bereicherung begreift und fördert.':
		'نحن ملتزمون بتعزيز التفاهم المتبادل والتعايش الإيجابي من خلال الحوار البناء. ويتم هذا التبادل على عدة مستويات ويشمل التعاون مع المجتمعات الإسلامية والمجموعات الدينية الأخرى والجمعيات والمؤسسات العلمانية. يعمل المركز الإسلامي للحوار والتعليم كنقطة التقاء مركزية ومنصة للتبادل بين الثقافات والأديان. نقوم بتنظيم مجموعة متنوعة من الفعاليات مثل سلسلة المحاضرات والندوات وورش العمل، والتي يتم تقديمها باللغتين الألمانية والعربية. تهدف هذه الأحداث إلى إعلام وتثقيف المسلمين وغير المسلمين على حد سواء. ومن خلال هذه العروض التعليمية، نسعى جاهدين لتحديد القواسم المشتركة، وتوضيح سوء الفهم، والحد من الأحكام المسبقة. هدفنا هو تعزيز التفاهم والاحترام العميق بين المجتمعات المختلفة والعمل معًا من أجل التعايش السلمي في مجتمعنا. وبهذا المعنى، يعمل IZDB كمركز نابض بالحياة للتعلم والحوار الذي يعترف بتنوع الثقافات والأديان ويعززه باعتباره إثراءً.',
	'Laden Sie die App herunter': 'حمل التطبيق',
	'Weiter lesen': 'اقرأ المزيد',
	'Das Interkulturelle Zentrum': 'يُقدّم المركز الثقافي',
	'für Dialog und Bildung e.V.': 'للحوار والتعليم IZDB',
	'Ziele und Visionen': 'الأهداف والرؤى',
	'Wir laden Sie herzlich ein, unsere Moschee kennenzulernen und mit uns in den Dialog zu treten. Nutzen Sie die Gelegenheit für einen offenen Austausch und bereichernde Gespräche!':
		'يسرنا دعوتكم لزيارة مسجدنا والمشاركة في حوار مفتوح وهادف. نحن نؤمن بأهمية التبادل الثقافي والديني، وندعوكم للانضمام إلينا في محادثات بنّاءة ومثمرة',
	'Willkommen in unserer Welt der Visionen, einfach und menschlich. Wir laden Sie herzlich ein, einen Blick auf einen kleinen, aber bedeutenden Ausschnitt unserer Arbeit zu werfen. Hier erhältst du einen tiefen Einblick in unser Engagement und unsere Ziele. Unsere Organisation widmet sich der Schaffung einer integrativen und verständnisvollen Gesellschaft, in der jeder Einzelne sich gesehen und gehört fühlt. Durch unsere vielfältigen Initiativen und Projekte streben wir danach, konkrete Veränderungen herbeizuführen, die sowohl lokal als auch global positive Auswirkungen haben.':
		'مرحباً بكم في عالمنا المليء بالرؤى البسيطة والإنسانية. ندعوك بكل سرور لإلقاء نظرة على مقتطف صغير ولكنه مهم من عملنا. هنا سوف تحصل على نظرة عميقة حول التزامنا وأهدافنا. تهدف منظمتنا إلى إنشاء مجتمع شامل ومتفهم حيث يشعر الجميع بأنهم مرئيون ومسموعون. ومن خلال مبادراتنا ومشاريعنا المتنوعة، نسعى جاهدين إلى إحداث تغييرات ملموسة ذات تأثيرات إيجابية على المستوى المحلي والعالمي.',
	'bietet einen offenen und einladenden Raum für alle, die Fragen zum Islam, zu Muslimen und ihrer Kultur haben. Das Zentrum dient als Plattform für Frieden, Besinnung und Bildung und fördert eine positive Kommunikation zwischen verschiedenen Kulturen und Religionen.':
		'مساحة مفتوحة ومرحبة للجميع ّ ممن لديهم تساؤلات عن الإسلام والمسلمين وثقافتهم. يُعد المركز منصةً للسلام والتأمل والتعليم، ويعزّز التواصل الإيجابي بين مختلف الثقافات والأديان',
	'Gestaltung gemeinsamer Integration': 'تصميم التكامل المشترك',
	'Wir engagieren uns leidenschaftlich für eine aktive Mitwirkung an der Integrationsarbeit, um eine diverse und inklusive Gesellschaft zu schaffen.':
		'نحن شغوفون بالمشاركة الفعالة في أعمال التكامل لخلق مجتمع متنوع وشامل.',
	'Aufklärungsarbeit für Verständnis': 'العمل التعليمي من أجل الفهم',
	'Unser Anliegen ist es, über den Islam aufzuklären – sowohl für Muslime als auch für Nichtmuslime – und so Brücken des Verständnisses zu bauen.':
		'هدفنا هو تثقيف الناس حول الإسلام - المسلمين وغير المسلمين - وبالتالي بناء جسور التفاهم.',
	'Förderung des friedlichen zusammenlebens': 'تعزيز التعايش السلمي',
	'Unser Ziel ist es, durch gezielte Initiativen und Projekte eine Kultur des friedlichen Zusammenlebens zu fördern, die kulturelle Vielfalt und Harmonie unterstützt.':
		'هدفنا هو تعزيز ثقافة التعايش السلمي التي تدعم التنوع الثقافي والانسجام من خلال المبادرات والمشاريع المستهدفة.',
	'Empowerment von Frauen und Jugendlichen': 'تمكين المرأة والشباب',
	'Wir setzen uns nachhaltig dafür ein, Frauen und Jugendliche zu unterstützen und zu stärken, damit sie ihre Potenziale voll entfalten können.':
		'نحن ملتزمون بدعم وتمكين المرأة والشباب حتى يتمكنوا من تطوير إمكاناتهم بالكامل.',

	'Unterstützung der Gemeinschaft': 'دعم المجتمع',
	'Wir sind bestrebt, das Wohlergehen unserer Gemeindemitglieder zu fördern, indem wir ein Netzwerk der Solidarität und Fürsorge schaffen.':
		'نحن نسعى جاهدين لتعزيز رفاهية أعضاء مجتمعنا من خلال إنشاء شبكة من التضامن والرعاية.',
	'Bildung als Schlüssel zur Zukunft': 'التعليم هو مفتاح المستقبل',
	'Durch den Einsatz effektiver Lernmethoden verbessern wir die Chancen unserer Mitglieder auf dem Arbeits- und Ausbildungsmarkt.':
		'من خلال استخدام أساليب التعلم الفعالة، نعمل على تحسين فرص أعضائنا في سوق العمل والتدريب.',
	'Partnerschaftliche Zusammenarbeit': 'التعاون القائم على الشراكة',
	'Wir streben nach Kooperationen mit Einrichtungen, Vereinen und Organisationen, die unsere Ziele teilen und sich im Einklang mit den Gesetzen Deutschlands für das Wohl der Gesellschaft einsetzen.':
		'نسعى إلى التعاون مع المؤسسات والجمعيات والمنظمات التي تشترك معنا في أهدافنا وتلتزم برفاهية المجتمع وفقًا للقانون الألماني.',

	'Das Kulturelle Zentrum für Dialog und Bildung (IZDB) bietet einen offenen und einladenden Raum für alle, die Fragen zum Islam, zu Muslimen und ihrer Kultur haben. Das Zentrum dient als Plattform für Frieden, Besinnung und Bildung und fördert eine positive Kommunikation zwischen verschiedenen Kulturen und Religionen.':
		'يُقدّم المركز الثقافي للحوار والتعليم (IZDB) مساحة مفتوحة ومرحّبة للجميع ممّن لديهم تساؤلات عن الإسلام والمسلمين وثقافتهم. يُعدّ المركز منصةً للسلام والتأمل والتعليم، ويعزّز التواصل الإيجابي بين مختلف الثقافات والأديان.',
	'IZDB Friedensplattform': 'منصة IZDB للسلام',
	'und gemeinsames Lernen': 'والتعلم المشترك',
	'Euer Zentrum braucht euch!': 'مركزكم بحاجة اليكم!',
	'Bewahre das Haus Allahs, so bewahrt Allah dich im Diesseits und Jenseits':
		'حافظ على بيت الله، يحفظك الله في الدنيا والآخرة',
	'Bitte schließen Sie die Bewertung ab, um die tägliche Leistungsdokumentation korrekt fortzusetzen. Die Bewertung wurde beim Schüler <u>{{studentName}} – {{seminar}}</u> unterbrochen.':
		'يرجى استكمال التقييم لضمان حفظ الأداء اليومي بدقة. توقفت عند الطالب: <u>{{studentName}} - {{seminar}}</u>',
	Uhr: 'الساعة',
	am: 'في',
	'Willkommen, {{name}}': 'مرحبًا، {{name}}',
	'Wir bitten Allah, deinen Einsatz zu segnen und das, was du gibst, dir als gute Tat anzurechnen.':
		'نسأل الله أن يبارك جهدك ويجعل ما تقدمه صدقة جارية لك.',
	'Kurs auswählen': 'اختر الدورة',
	Weiter: 'تابع',
	'Datum auswählen': 'اختر التاريخ',
	'Wöchentliche Leistung': 'الإنجاز الأسبوعي',
	Tage: 'الأيام',
	Pflichtinhalt: 'محتوى إلزامي',
	'Von Surah': 'من السورة',
	'Bis Surah': 'إلى السورة',
	'Möchten Sie den Schüler auf eine andere Stufe bringen?': 'هل تريد نقل الطالب إلى مستوى آخر؟',
	'Kurs beitreten': 'الانضمام إلى الدورة',
	Wiederholen: 'إعادة',
	'Prüfung nicht verfügbar': 'الامتحان غير متاح',
	Unterrichtsplan: 'خطة الدرس',
	Ergebnisübersicht: 'نظرة عامة على النتيجة',
	'Abzüge entfernen': 'إزالة الخصومات',
	'Der Abzug betrifft den gesamten Vers.': 'الخصم على الآية بأكملها',
	'Auswahl entfernen': 'إزالة الاختيار',
	'Weiter machen': 'المتابعة',
	'Bitte wähle sowohl "von" als auch "bis" für Verse oder Inhalte.':
		'يرجى اختيار كل من "من" و "إلى" للآيات أو المحتويات.',
	'Für öffentliche Kurse ist die Zeitplanung nicht erforderlich. Sie werden von der Verwaltung zugewiesen.':
		'بالنسبة للدورات العامة, لا يلزم التخطيط للوقت. سيتم تعيينها من قبل الإدارة.',
	'Der Lehrer hat noch nicht bestätigt': 'لم يؤكد المعلم بعد',
	'Schüler auswählen': 'اختيار طالب',
	'Andere Schüler auswählen': 'اختيار طالب اخر',
	'Wählen Sie einen Schüler aus': 'الرجاء اختيار طالب',
	Chat: 'الدردشة',
	'Meine Termine': 'مواعيدي',
	'Termin wiederholen?': 'تكرار الموعد؟',
	abgesagt: 'ملغى',
	'Unterricht mit {{name}}': 'الدروس مع {{name}}',
	'Termin stornieren oder ändern': 'إلغاء أو تغيير الموعد',
	' (Abgesagt)': ' (ملغى)',
	' (Abgelehnt)': ' (مرفوض)',
	' (Ausstehend)': ' (معلق)',
	' (Genehmigt)': ' (موافق عليه)',
	' (Abgeschlossen)': ' (مكتمل)',
	' (Abgebrochen)': ' (ملغي)',
	'Sie haben {{count}} Anfragen für Terminänderungen | Abwesenheiten':
		'لديك {{count}} طلبات لتغيير المواعيد | الغيابات',
	'Termine sehen': 'عرض المواعيد',
	'Aktive Unterhaltungen': 'المحادثات النشطة',
	'Verfügbare Benutzer': 'المستخدمين المتاحين',
	'Mehr laden': 'تحميل المزيد',
	'Bitte wählen Sie einen Chatraum aus, um mit dem Chatten zu beginnen.': 'يرجى اختيار غرفة دردشة لبدء الدردشة',
	'Abzüge zurückziehen': 'إلغاء الخصومات',
	'{{studentName}} Meeting beenden': '{{studentName}} إنهاء الاجتماع',
	'Möchten Sie das Meeting wirklich beenden?': 'هل تريد حقًا إنهاء الاجتماع؟',
	'Meeting beenden': 'إنهاء الاجتماع',
	'Kurs abgeschlossen': 'الدورة مكتملة',
	'Offene Unterrichtstermine': 'مواعيد الدروس المفتوحة',
	'Termin wurde storniert': 'تم إلغاء الموعد',
	'Geplante Unterrichtstermine': 'مواعيد الدروس المجدولة',
	Januar: 'يناير',
	Februar: 'فبراير',
	März: 'مارس',
	April: 'أبريل',
	Mai: 'مايو',
	Juni: 'يونيو',
	Juli: 'يوليو',
	August: 'أغسطس',
	September: 'سبتمبر',
	Oktober: 'أكتوبر',
	November: 'نوفمبر',
	Dezember: 'ديسمبر',
	'Warte auf Freischaltung': 'في انتظار التفعيل',
	'Bitte auswählen': 'يرجى الاختيار',
	'Abgeschlossenes Meeting': 'الاجتماعات المكتملة',
	Abgeschlossen: 'مكتمل',
	'Prüfungsnote: {{mark}}': 'درجة الامتحان: {{mark}}',
	Informationen: 'المعلومات',
	'Keine Fehler gefunden': 'لم يتم العثور على أخطاء',
	'Möchten Sie die Sitzung wirklich abschließen?': 'هل تريد حقًا إنهاء الجلسة؟',
	'Sitzung abschließen': 'إنهاء الجلسة',
	Notizen: 'الملاحظات',
	Hausaufgaben: 'الواجبات المنزلية',
	Unterrichtsinhalt: 'محتوى الدرس',
	'Von Inhalt': 'من المحتوى',
	'Bis Inhalt': 'إلى المحتوى',
	'Die Sitzung wurde erfolgreich abgeschlossen': 'تم إنهاء الجلسة بنجاح',
	'Von/Bis': 'من/إلى',
	Angefangen: 'بدأ',
	'Abgeschlossen am': 'اكتمل في',
	Ok: 'موافق',
	Erfolg: 'نجاح',
	Account: 'الحساب',
	'Quran lernen': 'تعلم القرآن',
	FAQ: 'الأسئلة الشائعة',
	Telefonnummer: 'رقم الهاتف',
	Sprache: 'اللغة',
	Kalender: 'التقويم',
	'Passwort ändern': 'تغيير كلمة المرور',
	Kontosicherheit: 'أمان الحساب',
	Nutzungsbedingungen: 'شروط الاستخدام',
	'Datenschutz und Nutzungsbedingungen': 'سياسة الخصوصية وشروط الاستخدام',
	Abmelden: 'تسجيل الخروج',
	'Account information': 'معلومات الحساب',
	Gehälter: 'الرواتب',
	Schüler: 'الطلاب',
	'Passwort aktualisieren': 'تحديث كلمة المرور',
	'Der Gesandte Allahs ﷺ sagte:': 'قال رسول الله ﷺ',
	'„Der Beste unter euch ist derjenige, der den Quran lernt und lehrt.“': '„خيركم من تعلم القرآن وعلمه.“',
	'Überliefert von al-Bukhari': 'رواه البخاري',
	Bildungsangelegenheiten: 'الشؤون التعليم',
	'Wöchentlicher Fortschrittsbericht zum {{date}}': 'تقرير التقدم الأسبوعي لـ {{date}}',
	'Bis zum {{prayerName}}-Gebet': 'بقي على صلاة {{prayerName}}',
	'Einfach beten, vielfach belohnt.': 'سهّل عبادتك، وعظّم أجرك',
	'Jetzt starten': 'ابدأ الآن',
	'Starte deine Koran-Reise.': 'ابدأ رحلتك مع القرآن الكريم.',
	'Jetzt registrieren und Rezitation & Tajwīd Schritt für Schritt lernen – mit erfahrenen Lehrern.':
		'أنشئ حسابك الآن وابدأ تعلم التلاوة والتجويد خطوة بخطوة مع نخبة من المعلمين المتخصصين.',
	'Die Besten unter euch sind diejenigen, die den Koran lernen und lehren.': 'خيركم من تعلم القرآن وعلمه.',
	'Schließe dich der Online-Muqra’a auf Qurani an – unserer Plattform für das Fernlernen, Rezitieren und Auswendiglernen des edlen Koran. Unter Anleitung erfahrener Lehrer, spezialisiert auf Tajwīd und Qirāāt.':
		'انضم إلى المقرأة الإلكترونية على قراني – منصتنا للتعلم عن بُعد، والتلاوة، وحفظ القرآن الكريم. تحت إشراف معلمين ذوي خبرة، متخصصين في التجويد والقراءات.',
	'Alle anzeigen': 'عرض الكل',
	'Neuste Nachrichten': 'أحدث الأخبار',
	'Neuste News': 'اخر الأخبار',
	'Aktivitäten und Veranstaltungen': 'الأنشطة والفعاليات',
	Werbung: 'الإعلانات',
	'Qualifizierte Lehrkräfte': 'معلمون مؤهلون',
	'Klassen und Kurse': 'الفصول والدورات',
	'Schüler/ innen': 'طالب وطالبة',
	'Auswendig-lerner': 'حافظ القرآن',
	'Korani in Zahlen': 'قرآني في أرقام',
	Suchen: 'بحث',
	'Beginne deinen Tag mit der Absicht, dein Bestes zu geben – du machst den Unterschied.':
		'ابدأ يومك بنية تقديم أفضل ما لديك – أنت تصنع الفرق.',
	'Die heutigen Aufgaben': 'المهام الواجبة عليك اليوم',
	'Anwesenheit/Abwesenheit erfassen': 'تسجيل الحضور/الغياب',
	'Anwesenheitsstatus jedes Schülers dokumentieren': 'توثيق حالة حضور كل طالب',
	'Schüler bewerten': 'تقييم الطلاب',
	'Festhalten, was jeder Schüler beherrscht': 'تدوين ما اتقنه كل طالب',
	'Inhalte und Hausaufgaben hinzufügen': 'إضافة المحتوى والواجبات',
	'Vorgaben hinzufügen, was jeder Schüler vorbereiten soll': 'إضافة ما يجب على كل طالب تحضيره',
	Anwesenheit: 'الحضور',
	'Wöchentl. Bewertung': 'التقييم الأسبوعي',
	'Monatliche Gehälter': 'الرواتب الشهرية',
	Schülerinfo: 'معلومات الطالب',
	Fehlern: 'الأخطاء',
	Anmelden: 'تسجيل الدخول',
	Lehrer: 'معلم',
	'Interaktive Karte': 'خريطة تفاعلية',
	Kontakt: 'اتصل بنا',
	'Hallo, {{name}}': 'اهلا {{name}}',
	'O Allah, mache uns und unsere Kinder zu den Leuten des Qurʾān, die zu Deinen Angehörigen und Deinen Auserwählten gehören.':
		'اللهم اجعلنا وأولادنا من أهل القرآن الذين هم أهلك وخاصتك',
	'Die letzte Rezitation erfolgte am <u>{{date}}</u>': 'آخر تسميع تم بتاريخ <u>{{date}}</u>',
	'Kurs: <u>{{courseName}}</u>': 'الدورة: <u>{{courseName}}</u>',
	'Zuletzt auswendig gelernt: <u>Qurʾān von {{fromSurahName}} ({{fromVerseId}}) bis {{toSurahName}} ({{toVerseId}}).</u>':
		'آخر ما تم حفظه: <u>القرآن من {{fromSurahName}} (الآية {{fromVerseId}}) إلى {{toSurahName}} (الآية {{toVerseId}}).</u>',
	'Gesamtprozentsatz der Einhaltung des Plans: <u>{{percentage}}%</u>':
		'النسبة الكلية للالتزام بالخطة: <u>{{percentage}}%</u>',
	Abonnenten: 'المشتركين',
	'Abonnenten auswählen': 'اختر المشتركين',
	'Nur im aktuellen Schuljahr verfügbar': 'متاح فقط في العام الدراسي الحالي',
	'Anzahl der Schüler': 'عدد الطلاب',
	'Rate der Aufgaben-erledigung': 'معدل إتمام المهام',
	'Dynamische Bewertung': 'التقييم الديناميكي',
	Ausstehend: 'معلق',
	'Koran lernen': 'تعلم القرآن',
	'Anwesenheitsstatus: <u>{{status}}</u>': 'حالة الحضور: <u>{{status}}</u>',
	'Nicht anwesend': 'غير متواجد',
	Hausaufgabe: 'الواجب المنزلي',
	'Keine Hausaufgaben gefunden': 'لم يتم العثور على واجبات منزلية',
	Geburtsort: 'مكان الميلاد',
	Kurs: 'الدورة',
	'Telefonnr.': 'رقم الهاتف',
	'Plan von {{fromContent}} bis {{toContent}}': 'الخطة من {{fromContent}} إلى {{toContent}}',
	'Alle Kurse': 'جميع الدورات',
	'Meine Schüler': 'طلابي',
	'In Koran aufmachen': 'افتح في القرآن',
	'Plan: <u>{{status}} {{readMore}}</u>': 'الخطة: <u>{{status}} {{readMore}}</u>',
	'Kein Plan gefunden': 'لم يتم العثور على خطة',
	'Schule auswählen': 'اختر المدرسة',
	Anfrage: 'استفسار',
	Anregung: 'اقتراح',
	Beschwerde: 'شكوى',
	'E-Mail oder Telefonnummer ist erforderlich': 'البريد الإلكتروني أو رقم الهاتف مطلوب',
	'Bitte eine gültige E-Mail oder Telefonnummer eingeben': 'يرجى إدخال بريد إلكتروني أو رقم هاتف صالح',
	'Passwort ist erforderlich': 'كلمة المرور مطلوبة',
	'Push-Benachrichtigungen': 'إشعارات الدفع',
	'Geschrieben am {{date}}': 'كتب في {{date}}',
	Anzeigen: 'عرض',
	Nachrichten: 'أخبار',
	'Aufnahmebed.': 'شروط القبول',
	'Programmde.': 'تفاصيل البرنامج',
	Episoden: 'الحلقات',
	Benutzername: 'اسم المستخدم',
	'Benutzername ist erforderlich': 'اسم المستخدم مطلوب',
	'Bitte eine gültige Benutzername eingeben': 'يرجى إدخال اسم مستخدم صالح',
	Passwort: 'كلمة المرور',
	'Bewertung nach abzugsfehlern: <u>{{mark}}</u>': 'التقييم بعد خصم الأخطاء: <u>{{mark}}</u>',
	'Bewertung anpassen': 'تعديل التقييم',
	'0 - Nicht bestanden': '0 - راسب',
	'1 - Wiederholen': '1 - إعادة',
	'2 - Wiederholen': '2 - إعادة',
	'3 - Mangelhaft': '3 - ضعيف',
	'4 - Mangelhaft': '4 - ضعيف',
	'5 - Ausreichend': '5 - مقبول',
	'6 - Mittel': '6 - متوسط',
	'7 - Gut': '7 - جيد',
	'8 - Sehr Gut': '8 - جيد جداً',
	'9 - Super': '9 - ممتاز',
	'10 - Super': '10 - ممتاز',
	Anwesend: 'متواجد',
	Abwesend: 'غير متواجد',
	Verspätet: 'متأخر',
	'Allgemeine Benachri.': 'إشعارات عامة',
	'Private Benachri.': 'إشعارات خاصة',
	'Inhalt hinzugefügt': 'تم إضافة المحتوى',
	'Hausaufgaben vergeben': 'تمت إضافة الواجبات',
	'Inhalt wurde hinzugefügt zu': 'تم إضافة المحتوى إلى',
	'Hausaufgaben wurden vergeben in': 'تمت إضافة الواجبات إلى',
	'Hinweis hinzugefügt für': 'تمت إضافة ملاحظة لـ',
	'Unbekannter Typ': 'نوع غير معروف',
	Benachrichtigung: 'إشعار',
	'Sitzung abschließen für {{name}}': 'إنهاء الجلسة لـ {{name}}',
	'Es wurde noch nichts rezitiert.': 'لم يتم التلاوة بعد.',
	'Kein Kurs zugewiesen.': 'لم يتم تعيين أي دورة.',
	'Zuletzt auswendig gelernt: <u>Es wurde noch nichts auswendig gelernt. </u>':
		'آخر ما تم حفظه: <u>لم يتم الحفظ بعد. </u>',
	'Keine Telefonnummer angegeben': 'لم يتم تقديم رقم هاتف',
	'Kein Geburtsdatum angegeben': 'لم يتم تقديم تاريخ الميلاد',
	'Keine Adresse angegeben': 'لم يتم تقديم عنوان',
	'Keine Sprache angegeben': 'لم يتم تقديم لغة',
	'Kein Geschlecht angegeben': 'لم يتم تقديم جنس',
	Fertig: 'مكتمل',
	'von {{fromContent}} bis {{toContent}}': 'من {{fromContent}} إلى {{toContent}}',
	'Es gibt keine Daten': 'لا توجد بيانات',
	'Bewertung nach abzugsfehlern: {{mark}}': 'التقييم بعد خصم الأخطاء: {{mark}}',
	'Fach auswählen': 'اختر المادة',
	"Um den Mushaf zu verwenden, muss der Materialtyp 'Koran' sein.": 'لاستخدام المصحف، يجب أن يكون نوع المادة "القرآن".',
	'Meta data': 'البيانات الوصفية',
	'Ticket Details': 'تفاصيل التذكرة',
	Ich: 'أنا',
	Sie: 'أنت',
	'Support-Team': 'فريق الدعم',
	Fragender: 'السائل',
	'Ticket details': 'تفاصيل التذكرة',
	Pfad: 'المسار',
	'Sie haben keine aktive Sitzung.': 'ليس لديك جلسة نشطة.',
	'Mehr lesen': 'اقرأ المزيد',
	'Keine Kommentare gefunden': 'لم يتم العثور على تعليقات',
	'Test Mode': 'وضع الاختبار',
	'App befindet sich im Testmodus, alle Daten werden nur im Testmodus gespeichert.':
		'التطبيق في وضع الاختبار، جميع البيانات سيتم حفظها فقط في وضع الاختبار.',
	'Koran- und Duaa-Erinnerungen': 'تذكيرات القرآن والدعاء',
	'Erinnerungen an Koran- und Duaa-Lektionen': 'تذكير بدروس القرآن والدعاء',
	'Ticketnummer: {{number}}': 'رقم التذكرة: {{number}}',
	'Andere Tickets': 'تذاكر أخرى',
	'Ticket Details: {{number}}': 'تفاصيل التذكرة: {{number}}',
	Geschlossen: 'مغلق',
	'Ticket auswählen': 'اختر تذكرة',
	'Neues Ticket öffnen': 'افتح تذكرة جديدة',
	'Andere Fächer bewerten': 'تقييم مواد أخرى',
	'Fächer die du bewertet hast': 'المواد التي قمت بتقييمها',
	'Keine Fächer zur Bewertung ausgewählt': 'لم يتم اختيار مواد للتقييم',
	'Bitte wähle einen Inhalt aus.': 'يرجى اختيار محتوى.',
	'Bitte wähle einen Kurs aus.': 'يرجى اختيار دورة.',
	'Bitte wähle ein Fach aus.': 'يرجى اختيار مادة.',
	'Bitte wähle einen Schüler aus.': 'يرجى اختيار طالب.',
	'Bitte wähle ein Datum aus.': 'يرجى اختيار تاريخ.',
	'Bitte wähle einen Anwesenheitsstatus aus.': 'يرجى اختيار حالة الحضور.',
	'Bitte wähle eine Bewertung aus.': 'يرجى اختيار تقييم.',
	'Bitte gib einen Titel ein.': 'يرجى إدخال عنوان.',
	'Bitte wähle einen Startinhalt aus.': 'يرجى اختيار محتوى البداية.',
	'Bitte wähle einen Endinhalt aus.': 'يرجى اختيار محتوى النهاية.',
	'Bitte wähle ein Startdatum aus.': 'يرجى اختيار تاريخ البداية.',
	'Das Startdatum muss vor dem Enddatum liegen.': 'يجب أن يكون تاريخ البدء قبل تاريخ الانتهاء.',
	'Bitte wähle ein Enddatum aus.': 'يرجى اختيار تاريخ الانتهاء.',
	'Bitte wähle einen Status aus.': 'يرجى اختيار حالة.',
	'Neuen Plan erstellen': 'إنشاء خطة جديدة',
	Pläne: 'الخطط',
	Von: 'من',
	Bis: 'إلى',
	'Von Zeit': 'من الوقت',
	'Bis Zeit': 'إلى الوقت',
	'Koran von {{fromSuraName}} “{{fromAaya}} ({{fromAayaId}})”':
		'القرآن من {{fromSuraName}} "{{fromAaya}} (الآية {{fromAayaId}})"',
	'Bis {{toSuraName}} “{{toAaya}} ({{toAayaId}})”': 'إلى {{toSuraName}} "{{toAaya}} (الآية {{toAayaId}})"',
	'Inhalt von {{fromContent}} bis {{toContent}}': 'المحتوى من {{fromContent}} إلى {{toContent}}',
	'mehr lesen': 'اقرأ المزيد',
	'Haupt Pläne': 'الخطط الرئيسية',
	Fach: 'المادة',
	'Schüler auswählen (Option)': 'اختيار طلاب (اختياري)',
	'Feld ist erforderlich': 'الحقل مطلوب',
	'Bitte wähle einen Zielinhalt aus.': 'يرجى اختيار محتوى الهدف.',
	Löschen: 'حذف',
	'Passwort vergessen?': 'نسيت كلمة المرور؟',
	Rechnungen: 'الفواتير',
	Rechnungsnummer: 'رقم الفاتورة',
	Anzahl: 'الكمية',
	Lernfortschritt: 'متابعة التعليم',
	Neu: 'جديد',
	'Bildungsweg wählen': 'اختر مسار التعليم',
	Inaktiv: 'غير نشط',
	Kursdetails: 'تفاصيل الدورة',
	Abgebrochen: 'ملغي',
	Unbekannt: 'غير معروف',
	Akzeptiert: 'مقبول',
	Abgelehnt: 'مرفوض',
	'Stornierung angefragt': 'تم طلب الإلغاء',
	'Bildungsweg auswählen': 'اختر مسار التعليم',
	'Juz {{juzNumber}}': 'جزء {{juzNumber}}',
	Postleitzahl: 'الرمز البريدي',
	Nationalität: 'الجنسية',
	'Abonnenten Details': 'تفاصيل المشتركين',
	'Es wurde keine Sitzung gefunden.': 'لم يتم العثور على جلسة.',
	'Abonnent Details': 'تفاصيل المشترك',
	Bezahlen: 'ادفع',
	'Name oder Nummer der Surah': 'اسم السورة أو رقمها',
	'Für das ausgewählte Datum sind keine Seminare vorhanden.': 'لا توجد ندوات في التاريخ المحدد.',
	'Schüleranzahl: {{count}}': 'عدد الطلاب: {{count}}',
	'Alle Schulen': 'جميع المدارس',
	'Tag auswählen': 'اختر اليوم',
	Seminare: 'الفصول الدراسية',
	'Account auswählen': 'اختر الحساب',
	'Kurs ansehen': 'عرض الدورة',
	'{{day}}s. Kreis': 'حلقة {{day}}',
	Unterrichtszeit: 'اوقات الدوام',
	'Persönliche Informationen': 'المعلومات الشخصية',
	'Programm auswählen': 'اختر البرنامج',
	'Lehrer auswählen': 'اختر المعلم',
	'Adresse auf Karte anzeigen': 'عرض العنوان على الخريطة',
	'Nicht verfügbar': 'غير متاح',
	Programmart: 'نوع البرنامج',
	Startdatum: 'تاريخ البدء',
	Enddatum: 'تاريخ الانتهاء',
	Männlich: 'ذكر',
	Weiblich: 'أنثى',
	'Ihre Informationen': 'معلوماتك',
	'Überprüfen Sie Ihre Informationen, bevor Sie sich anmelden': 'تحقق من معلوماتك قبل التسجيل',
	'Verfügbare Zahlungsmöglichkeiten': 'طرق الدفع المتاحة',
	'Zahlungsmethode auswählen': 'اختر طريقة الدفع',
	'Noch keinen Account? Registrieren': 'ليس لديك حساب؟ سجل الآن',
	'{{name}} - Anzahl der Raten: {{count}} - Betrag pro Rate: {{payment}}€':
		'{{name}} - عدد الأقساط: {{count}} - المبلغ لكل قسط: {{payment}}€',
	Straße: 'الشارع',
	Schule: 'المدرسة',
	Programm: 'البرنامج',
	Zeit: 'الوقت',
	Registrieren: 'انشاء حساب',
	Anmeldung: 'تسجيل الدخول',
	'Bitte melden Sie sich an, um fortzufahren': 'يرجى تسجيل الدخول للمتابعة.',
	'Erfolgreich abonniert!': 'تم الاشتراك بنجاح',
	'Abonnement ausstehend': 'الاشتراك معلق',
	'Abonnement fast abgeschlossen': 'الاشتراك شبه مكتمل',
	'Abonnement fehlgeschlagen': 'فشل الاشتراك',
	'Du hast dich erfolgreich für das Koranprogramm angemeldet. Wir freuen uns darauf, dich auf dieser Reise zu begleiten!':
		'لقد تم تسجيلك بنجاح في برنامج القرآن. نحن نتطلع إلى مرافقتك في هذه الرحلة!',
	'Deine Anmeldung ist eingegangen und wird derzeit bearbeitet. Wir werden dich benachrichtigen, sobald sie bestätigt ist.':
		'تم استلام تسجيلك وهو قيد المعالجة حاليًا. سنقوم بإعلامك بمجرد تأكيده.',
	'Fast geschafft! Bitte melde dich von der Website, um deine Anmeldung abzuschließen. Klicke auf den Link':
		'قريبًا! يرجى تسجيل الدخول من الموقع لإكمال تسجيلك. انقر على الرابط',
	'Fast geschafft! Bitte melde dich von der Website, um deine Anmeldung abzuschließen.':
		'قريبًا! يرجى تسجيل الدخول من الموقع لإكمال تسجيلك.',
	'Leider gab es ein Problem mit deiner Anmeldung. Bitte versuche es erneut oder kontaktiere unseren Support für Hilfe.':
		'عذرًا، حدثت مشكلة في تسجيلك. يرجى المحاولة مرة أخرى أو الاتصال بدعمنا للحصول على المساعدة.',
	'Zur Startseite': 'العودة إلى الصفحة الرئيسية',
	Kosten: 'التكلفة',
	Kostenlos: 'مجاني',
	Kostenpflichtig: 'مدفوع',
	Rabatt: 'الخصم',
	Gesamt: 'المجموع',
	'Niveau auswählen': 'اختر المستوى',
	'Bitte wählen Sie Ihr Niveau aus, um fortzufahren': 'يرجى اختيار مستواك للمتابعة',
	'Programcode eingeben': 'أدخل رمز البرنامج',
	'Dieses Programm ist privat. Bitte geben Sie den Code ein, um fortzufahren.':
		'هذا البرنامج خاص. يرجى إدخال الرمز للمتابعة.',
	'Der eingegebene Code ist ungültig. Bitte versuchen Sie es erneut.':
		'الرمز الذي تم إدخاله غير صالح. يرجى المحاولة مرة أخرى.',
	'Code überprüfen': 'التحقق من الرمز',
	'Rabattcode eingeben': 'أدخل رمز الخصم',
	'Code eingeben': 'أدخل الرمز',
	Öffentlich: 'عام',
	'Rabattcode wurde erfolgreich angewendet!': 'تم تطبيق رمز الخصم بنجاح!',
	'Der Code wurde erfolgreich angewendet!': 'تم تطبيق الرمز بنجاح!',
	'Deine Anmeldung war erfolgreich!': 'تم تسجيلك بنجاح!',
	'Link öffnen': 'فتح الرابط',
	'Fast geschafft! Bitte klicke auf den Link, um deine Anmeldung abzuschließen.':
		'قريبًا! يرجى الضغط على الرابط لإكمال اشتراكك.',
	'Fast geschafft! Bitte klicke auf den Link, um deine Abonnement abzuschließen.':
		'قريبًا! يرجى الضغط على الرابط لإكمال اشتراكك.',
	'Leider gab es ein Problem mit deiner Abonnement. Bitte versuche es erneut oder kontaktiere unseren Support für Hilfe.':
		'عذرًا، حدثت مشكلة في اشتراكك. يرجى المحاولة مرة أخرى أو الاتصال بدعمنا للحصول على المساعدة.',
	Deutschland: 'ألمانيا',
	Syrien: 'سوريا',
	Libanon: 'لبنان',
	Palästina: 'فلسطين',
	Jordanien: 'الأردن',
	Ägypten: 'مصر',
	Irak: 'العراق',
	Marokko: 'المغرب',
	Tunesien: 'تونس',
	Algerien: 'الجزائر',
	'Saudi-Arabien': 'السعودية',
	'Vereinigte Arabische Emirate': 'الإمارات العربية المتحدة',
	Katar: 'قطر',
	Bahrain: 'البحرين',
	Oman: 'عمان',
	Jemen: 'اليمن',
	Keiner: 'لا يوجد',
	'Geben Sie Ihren Coupon-Code ein': 'أدخل رمز القسيمة الخاص بك',
	'Telefonnummer ist erforderlich': 'رقم الهاتف مطلوب',
	'Telefonnummer (inkl. Ländervorwahl, z.B. +491234567890)':
		'+رقم الهاتف (بما في ذلك رمز البلد، على سبيل المثال 491771234567',
	'Bitte eine gültige Telefonnummer im Format +491771234567 eingeben': '+يرجى إدخال رقم هاتف صالح مثال 491771234567',
	Code: 'رمز',
	'OTP erneut senden': 'إعادة إرسال OTP',
	'OTP wird gesendet...': 'يتم إرسال OTP...',
	'Bitte einen gültigen OTP eingeben': 'يرجى إدخال OTP صالح',
	'Passwort bestätigen ist erforderlich': 'تأكيد كلمة المرور مطلوب',
	'Passwort bestätigen': 'تأكيد كلمة المرور',
	'Benutzername muss mindestens 3 Zeichen lang sein': 'يجب أن يكون اسم المستخدم 3 أحرف على الأقل',
	'Benutzername darf nur Buchstaben, Zahlen, Punkte, Unterstriche und Bindestriche enthalten':
		'اسم المستخدم يمكن أن يحتوي فقط على أحرف اجنبية، أرقام، نقاط، شرطات سفلية وشرطات',
	'Passwort muss mindestens 6 Zeichen lang sein': 'يجب أن تكون كلمة المرور 6 أحرف على الأقل',
	'Telefonnummer ändern': 'تغيير رقم الهاتف',
	'{{name}} darf nur Englische Buchstaben, Bindestriche und Leerzeichen enthalten':
		'{{name}} يمكن أن يحتوي فقط على أحرف انجليزية، شرطات و مسافات',
	'{{name}} muss mindestens 5 Zeichen lang sein': '{{name}} يجب أن يكون 5 أحرف على الأقل',
	'{{name}} muss maximal 10 Zeichen lang sein': '{{name}} يجب أن يكون 10 أحرف كحد أقصى',
	'Kapitel {{number}}': 'الفصل {{number}}',
	'Juz {{number}}': 'الجزء {{number}}',
	'Surah {{name}}': '{{name}}',
	'Seite {{number}}': 'الصفحة {{number}}',
	'Passwort wird zurückgesetzt...': 'يتم إعادة تعيين كلمة المرور...',
	'Suche oder gehe zu Seite': 'ابحث أو انتقل إلى الصفحة',
	Suren: 'السور',
	Ayat: 'الآيات',
	'Bewertungsdatum: {{date}}': 'تاريخ التقييم: {{date}}',
	Bewertungs: 'التقييم',
	Bewertung: 'التقييم',
	'Name des Plans': 'اسم الخطة',
	'Plan hinzugefügt': 'تمت إضافة الخطة',
	Gebetszeiten: 'مواقيت الصلاة',
	'Mehr anzeigen': 'مشاهدة المزيد',
	'Wählen Sie das passende Abonnement': 'اختر الاشتراك المناسب',
	Zugewiesen: 'تم تحديد الحلقة',
	'Warten auf Zuweisung': 'بانتظار تعيين الحلقة',
	'Abonnement erneuern': 'اضغط لتجديد الاشتراك',
	'Erneuert, bitte warten': 'تم التجديد، الرجاء الانتظار',
	'Zahlung ausstehend': 'بإنتظار اتمام الدفع',
	'Kein Konto ausgewählt': 'لم يتم اختيار حساب معلم بعد',
	'Stufe: <u>{{level}}</u>': 'المستوى: <u>{{level}}</u>',
	'Gebühren pro Monat: <u>{{price}}</u>': 'الرسوم الشهرية: <u>{{price}}</u>',
	'Anmeldegebühren: <u>{{price}}</u>': 'رسوم التسجيل: <u>{{price}}</u>',
	'Startdatum: <u>{{startDate}}</u>': 'تاريخ البدء: <u>{{startDate}}</u>',
	'Keine Treffer gefunden.': 'لم يتم العثور على نتائج.',
	'Username (E-Mail | Telefonnummer)': 'اسم المستخدم (البريد الإلكتروني | رقم الهاتف)',
	'E-Mail ist erforderlich': 'حقل الايميل اجباري',
	'OTP wird überprüft...': 'يتم فحص الكود',
	'Telefonnummer wiederholen': 'اعادة رقم الهاتف',
	'Neue Schüler hinzufügen': 'إضافة طالب جدد',
	'Bitte eine gültige E-Mail eingeben': 'يرجى إدخال بريد إلكتروني صالح',
	'E-Mail ändern': 'تغيير البريد الإلكتروني',
	Registrierung: 'انشاء حساب جديد',
	'Erfolgreich gespeichert': 'تم الحفظ بنجاح',
	'Sitzung erfolgreich abgeschlossen': 'تم الانتهاء من الجلسة بنجاح',
	'Bitte fügen Sie eine Zahlungsmethode hinzu, damit die Zahlung funktioniert.':
		'يرجى إضافة طريقة دفع حتى تتمكن من إتمام الدفع.',
	Einfügen: 'إضافة',
	'Zahlungsmethode hinzufügen': 'إضافة طريقة دفع',
	'OTP anfordern': 'طلب رمز التحقق',
	Bestätigen: 'تأكيد',
	Zahlungsmethode: 'طريقة الدفع',
	'Zahlungsmethode ändern': 'تغيير طريقة الدفع',
	'Passwörter müssen übereinstimmen': 'يجب أن تتطابق كلمات المرور',
	'Ein Fehler ist aufgetreten': 'حدث خطأ',
	'In das neue Schuljahr wechseln': 'الانتقال إلى العام الدراسي الجديد',
	Wechseln: 'تغيير',
	'Vielen Dank für Ihre Anmeldung!': 'شكراً لتسجيلك!',
	'Koran Al-Karim': 'القرآن الكريم',
	Bestätigung: 'تأكيد',
	'Sind Sie sicher, dass Sie diese Aktion durchführen möchten?': 'هل أنت متأكد أنك تريد تنفيذ هذا الإجراء؟',
	'Abonnement kündigen': 'إلغاء الاشتراك',
};
